import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosBrToursViagem = {
    ...dadosAgenciaComum,
    id: 'brtoursviagem',
    nome: 'BR Tours Viagem',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
